<template>

    <v-form
            ref="modifyUserForm"
            @submit.prevent=""
            class=""
            :disabled="loading"
    >
        <div class="d-flex align-center primary pl-3 pr-2">
            <div class="flex-grow-1 sub--text">
                {{pin.id ? 'Edit HR User' : 'Create HR User'}}
            </div>
            <div v-if="!pin.id">
                <v-btn
                        icon
                        color="white"
                        small
                        @click="$emit('dismiss')"
                >
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </div>
        </div>
        <v-divider></v-divider>
        <div class="pb-3">

            <div class=" px-4">
                <v-text-field
                        label="Name"
                        hide-details="auto"
                        v-model="pin.name"
                        @change="changesMade = true"
                        :rules="[validationRules.required, validationRules.notNull]"
                />
                <v-text-field
                        label="Pin Code"
                        hide-details="auto"
                        v-model="pin.pin"
                        @change="changesMade = true"
                        :rules="[fiveNumericCharacters]"
                />
                <v-switch
                        label="Disabled"
                        color="primary"
                        v-model="pin.disabled"
                        hide-details
                        @change="changesMade = true"
                ></v-switch>
            </div>



        </div>
        <div style="position: absolute; bottom: 0; right: 0" class="pa-2">
            <v-btn
                    @click="validateSave()"
                    fab
                    small
                    color="secondary"
                    :loading="loading"
                    :disabled="!changesMade || loading"
            >
                <v-icon v-if="!loading">mdi-content-save</v-icon>
            </v-btn>
        </div>
    </v-form>


</template>

<script>
import {mapGetters} from 'vuex';
import {validationRules} from "../../../core/codeFunctions";
import Divider from "../../General/Divider";

export default {
    components: {Divider},
    props: {
        editPin: Object,
        showBarcodes: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            pin: false,
            changesMade: false,
            validationRules: validationRules,
            pinNameErrorMessages: null,
            loading: false,
            editPassword: false
        }
    },
    watch: {
        editPin: {
            deep: true,
            immediate: true,
            handler(val) {
                this.edit = false;
                this.changesMade = false
                this.pin = JSON.parse(JSON.stringify(val))
            }
        },
        "pin.name"() {
            this.pinNameErrorMessages = null
        }
    },
    methods: {
        fiveNumericCharacters(value) {
            if (this.hrPinsValues.includes(value))
                return "Pin Has Already Been Used"
            if (!value)
                return "Pin Code Required"
            if (value.length !== 5)
                return "5 Digits Required"
            if (value.match(/^[0-9]{5}$/gm))
                return true
            return "5 Numeric Digits Required"
        },
        validateSave() {
            // Check Username
            if (!this.$refs.modifyUserForm.validate())
                return this.$snack.error("Please Complete All Required Fields")
            this.$emit('save', {pin: this.pin, ref: this})
        }
    },
    computed: {
        ...mapGetters(['hrPins']),
        hrPinsValues() {
            return this.hrPins.filter(pin => pin.id !== this.pin.id).map(val => val.pin)
        }
    },
}
</script>

<style scoped>

</style>